import { render, staticRenderFns } from "./CommentContentWithTranslation.vue?vue&type=template&id=6c0b589a&"
import script from "./CommentContentWithTranslation.vue?vue&type=script&lang=js&"
export * from "./CommentContentWithTranslation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports